const permissions = {
  listCustomers: 'CS001',
  addCustomers: 'CS002',
  editCustomers: 'CS002',
  removeCustomers: 'CS003'
};

export default permissions;
